<ng-container [formGroup]="form">
  <ng-container *ngIf="(fp !== 'place_' && form.get(fp + 'addressOutsideCountry').value === false) || fp === 'place_'">
    <div nz-row [nzGutter]="16">
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="{{ fp }}addressVoivodeshipId">
            {{ 'COMMON.LABEL.VOIVODESHIP' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-select
              formControlName="{{ fp }}addressVoivodeshipId"
              nzPlaceHolder="{{ 'COMMON.PLACEHOLDER.SELECT_VOIVODESHIP' | translate }}"
              nzNotFoundContent="{{ 'COMMON.LABEL.NO_VOIVODESHIPS_LOADED' | translate }}"
              nzShowSearch>
              <nz-option *ngFor="let voivo of voivodeships" [nzValue]="voivo.id" [nzLabel]="voivo.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="{{ fp }}addressDistrictId">
            {{ 'COMMON.LABEL.DISTRICT' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-select
              formControlName="{{ fp }}addressDistrictId"
              [nzDisabled]="!form.get(fp + 'addressVoivodeshipId')?.value"
              nzPlaceHolder=" {{ 'COMMON.PLACEHOLDER.SELECT_DISTRICT' | translate }} "
              nzNotFoundContent="{{ 'COMMON.LABEL.NO_DISTRICTS_LOADED' | translate }}"
              [nzLoading]="loadingDistricts"
              nzShowSearch>
              <nz-option
                *ngFor="let district of districts"
                [nzValue]="district.id"
                [nzLabel]="district.MOS_name.toUpperCase() + ' (' + district.MOS_extra_name + ')'">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="{{ fp }}addressMunicipalityId">
            {{ 'COMMON.LABEL.MUNICIPALITY' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-select
              formControlName="{{ fp }}addressMunicipalityId"
              [nzDisabled]="!form.get(fp + 'addressDistrictId')?.value"
              nzPlaceHolder=" {{ 'COMMON.PLACEHOLDER.SELECT_MUNICIPALITY' | translate }} "
              nzNotFoundContent="{{ 'COMMON.LABEL.NO_MUNICIPALITIES_LOADED' | translate }}"
              [nzLoading]="loadingMunicips"
              nzShowSearch>
              <nz-option
                *ngFor="let municip of municips"
                [nzValue]="municip.id"
                [nzLabel]="municip.MOS_name.toUpperCase()">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="{{ fp }}addressCityId">
            {{ 'COMMON.LABEL.CITY' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-select
              formControlName="{{ fp }}addressCityId"
              [nzDisabled]="!form.get(fp + 'addressMunicipalityId')?.value"
              nzPlaceHolder=" {{ 'COMMON.PLACEHOLDER.SELECT_CITY' | translate }} "
              nzNotFoundContent="{{ 'COMMON.LABEL.NO_CITIES_LOADED' | translate }}"
              [nzLoading]="loadingCities"
              nzShowSearch>
              <nz-option *ngFor="let city of cities" [nzValue]="city.id" [nzLabel]="city.MOS_name.toUpperCase()">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="16">
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="{{ fp }}addressZipCode">
            {{ 'COMMON.LABEL.ZIPCODE' | translate }}
          </nz-form-label>
          <nz-form-control>
            <input nz-input [mask]="'99-999'" formControlName="{{ fp }}addressZipCode" id="{{ fp }}addressZipCode" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="{{ fp }}addressStreet">
            {{ 'COMMON.LABEL.STREET_NAME' | translate }}
          </nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="{{ fp }}addressStreet" id="{{ fp }}addressStreet" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="{{ fp }}addressHouseNumber">
            {{ 'COMMON.LABEL.HOUSE_NUMBER' | translate }}
          </nz-form-label>
          <nz-form-control>
            <input
              nz-input
              [maxlength]="15"
              formControlName="{{ fp }}addressHouseNumber"
              id="{{ fp }}addressHouseNumber" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="{{ fp }}addressApartmentNumber">
            {{ 'COMMON.LABEL.APARTMENT_NUMBER' | translate }}
          </nz-form-label>
          <nz-form-control>
            <input
              nz-input
              [maxlength]="15"
              formControlName="{{ fp }}addressApartmentNumber"
              id="{{ fp }}addressApartmentNumber" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="fp !== 'place_' && form.get(fp + 'addressOutsideCountry').value === true">
    <div nz-row [nzGutter]="16">
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="{{ fp }}externalAddressCountry">
            {{ 'COMMON.LABEL.COUNTRY' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-select
              formControlName="{{ fp }}externalAddressCountry"
              nzPlaceHolder="{{ 'COMMON.PLACEHOLDER.SELECT_COUNTRY' | translate }}"
              nzNotFoundContent="{{ 'COMMON.LABEL.NO_COUNTRIES_LOADED' | translate }}"
              nzShowSearch>
              <nz-option
                *ngFor="let country of countries"
                [nzValue]="country.name"
                [nzLabel]="country.nameTranslations[currLang]">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="{{ fp }}externalAddressCity">
            {{ 'COMMON.LABEL.CITY' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <input nz-input formControlName="{{ fp }}externalAddressCity" id="{{ fp }}externalAddressCity" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="{{ fp }}externalAddressStreet">
            {{ 'COMMON.LABEL.STREET_NAME' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <input nz-input formControlName="{{ fp }}externalAddressStreet" id="{{ fp }}externalAddressStreet" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="16">
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="{{ fp }}externalAddressZipCode">
            {{ 'COMMON.LABEL.ZIPCODE' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <input
              nz-input
              [maxlength]="10"
              formControlName="{{ fp }}externalAddressZipCode"
              id="{{ fp }}externalAddressZipCode" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="{{ fp }}externalAddressHouseNumber">
            {{ 'COMMON.LABEL.HOUSE_NUMBER' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <input
              nz-input
              [maxlength]="15"
              formControlName="{{ fp }}externalAddressHouseNumber"
              id="{{ fp }}externalAddressHouseNumber" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="{{ fp }}externalAddressApartmentNumber">
            {{ 'COMMON.LABEL.APARTMENT_NUMBER' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <input
              nz-input
              [maxlength]="15"
              formControlName="{{ fp }}externalAddressApartmentNumber"
              id="{{ fp }}externalAddressApartmentNumber" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </ng-container>

  <ng-template #inputStandardErrors let-control>
    <ng-container *ngIf="control.hasError('maxlength')">{{
      'COMMON.LABEL.MAX_LENGTH_EXCEEDED' | translate
    }}</ng-container>
    <!-- <ng-container *ngIf="control.hasError('minlength')">MinLength is 6</ng-container> -->
    <ng-container *ngIf="control.hasError('required')">
      {{ 'COMMON.VALIDATOR.FIELD_IS_REQUIRED' | translate }}</ng-container
    >
  </ng-template>
</ng-container>
